import React, { useEffect, useState } from 'react';
import Loading from '../../loading/Loading';
import TableLayout, { TD, selectSx } from '../../ui/TableLayout';
import { EditBtn, DeleteBtn, InadimplenciasBtn, Actions } from '../../ui/ActionButtons';
import Apis from '../../Apis';
import axios from 'axios';
import { FiTrash2, FiX } from 'react-icons/fi';

const COLS = ['Cliente', 'CPF / CNPJ', 'Cidade', 'UF', 'Status', 'Ações'];
const headers = () => ({ 'Content-Type': 'application/json', Authorization: localStorage.getItem('token') });

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(`${value}T00:00:00`);
  return Number.isNaN(date.getTime()) ? value : date.toLocaleDateString('pt-BR');
};

const formatMoney = (value) => Number(value || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

function InadimplenciasModal({ cliente, onClose }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const loadItems = () => {
    setLoading(true);
    console.log(`${Apis.urlListarInadimplencias}/${cliente.id}`);
    
    setError('');
    fetch(`${Apis.urlListarInadimplencias}/${cliente.id}`, { headers: headers() })
      .then(response => {
        console.log('[Inadimplências] status da listagem:', response.status);
        return response.json().then(body => {
          console.log('[Inadimplências] retorno da listagem:', body);
          if (!response.ok) throw new Error('Não foi possível carregar as inadimplências.');
          return body;
        });
      })
      .then(response => setItems(response.dados || response.registros || []))
      .catch(error => {
        console.error('[Inadimplências] erro na listagem:', error);
        setError('Não foi possível carregar as inadimplências deste cliente.');
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { loadItems(); }, [cliente.id]); // eslint-disable-line

  const handleDelete = (item) => {
    
    if (!window.confirm(`Excluir a inadimplência do documento ${item.doc}?`)) return;
    fetch(`${Apis.urlListarInadimplencias}/${item.id}`, {
      method: 'DELETE',
      headers: headers(),
    })
      .then(response => {
        console.log('[Inadimplências] status da exclusão:', response.status);
        return response.json().then(body => {
          console.log('[Inadimplências] retorno da exclusão:', body);
          if (!response.ok) throw new Error('Falha ao excluir');
          return body;
        });
      })
      .then(() => {
        setItems(current => current.filter(currentItem => currentItem.id !== item.id));
      })
      .catch(error => {
        console.error('[Inadimplências] erro na exclusão:', error);
        setError('Não foi possível excluir esta inadimplência.');
      });
  };

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 9999, background: 'rgba(15,23,42,0.55)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }} onClick={onClose}>
      <div style={{ width: 'min(680px, 100%)', maxHeight: '80vh', overflow: 'hidden', background: '#fff', borderRadius: 8, boxShadow: '0 24px 64px rgba(0,0,0,0.18)' }} onClick={event => event.stopPropagation()}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '18px 20px', borderBottom: '1px solid #e5e7eb' }}>
          <div>
            <strong style={{ color: '#111827' }}>Inadimplências</strong>
            <div style={{ marginTop: 3, fontSize: 12, color: '#6b7280' }}>{cliente.nome}</div>
          </div>
          <button type="button" title="Fechar" aria-label="Fechar" onClick={onClose} style={{ border: 0, background: 'none', cursor: 'pointer', color: '#6b7280' }}><FiX size={18} /></button>
        </div>
        <div style={{ padding: 20, overflowY: 'auto', maxHeight: 'calc(80vh - 88px)' }}>
          {loading && <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>Carregando...</div>}
          {!loading && error && <div style={{ padding: 12, color: '#b91c1c', background: '#fef2f2', borderRadius: 4 }}>{error}</div>}
          {!loading && !error && items.length === 0 && <div style={{ padding: 24, textAlign: 'center', color: '#6b7280' }}>Nenhuma inadimplência encontrada.</div>}
          {!loading && !error && items.length > 0 && (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead><tr style={{ color: '#6b7280', textAlign: 'left', borderBottom: '1px solid #e5e7eb' }}>
                <th style={{ padding: '8px 6px' }}>Documento</th><th style={{ padding: '8px 6px' }}>Data</th><th style={{ padding: '8px 6px' }}>Vencimento</th><th style={{ padding: '8px 6px', textAlign: 'right' }}>Valor</th><th />
              </tr></thead>
              <tbody>{items.map(item => (
                <tr key={item.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '10px 6px' }}>{item.doc || '-'}</td>
                  <td style={{ padding: '10px 6px' }}>{formatDate(item.data_doc)}</td>
                  <td style={{ padding: '10px 6px' }}>{formatDate(item.vencimento)}</td>
                  <td style={{ padding: '10px 6px', textAlign: 'right' }}>{formatMoney(item.valor)}</td>
                  <td style={{ padding: '10px 6px', textAlign: 'right' }}><button type="button" title="Excluir inadimplência" aria-label="Excluir inadimplência" onClick={() => handleDelete(item)} style={{ border: 0, background: 'none', color: '#ef4444', cursor: 'pointer' }}><FiTrash2 size={14} /></button></td>
                </tr>
              ))}</tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}

const StatusBadge = ({ status }) => {
  const s = String(status);
  const cfg = s === '0'
    ? { label: 'Ativo',   bg: 'rgba(16,185,129,0.1)', color: '#059669' }
    : s === '1'
    ? { label: 'Inativo', bg: 'rgba(239,68,68,0.1)',  color: '#dc2626' }
    : { label: 'Status desconhecido', bg: 'rgba(245,158,11,0.1)', color: '#b45309' };
  return (
    <span style={{ display: 'inline-block', padding: '2px 12px', borderRadius: 40, background: cfg.bg, color: cfg.color, fontSize: 11, fontWeight: 600 }}>
      {cfg.label}
    </span>
  );
};

export default function ListaClientes() {
  const [search, setSearch]   = useState('');
  const [status, setStatus]   = useState('-1');
  const [perPage, setPerPage] = useState(25);
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(true);
  const [inadimplenciasCliente, setInadimplenciasCliente] = useState(null);

  const fetchData = (s = status, pp = perPage, q = search) => {
    setLoading(true);
    const body = { pesquisa: q, qtd_registros: pp, status: s };
    axios.post(Apis.urlListarClientes, body, { headers: headers() })
      .then(res => setData(res.data.registros || []))
      .catch(() => setData([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchData(); }, []); // eslint-disable-line

  const handlePerPage = (val) => { setPerPage(val); fetchData(status, val); };

  const Toolbar = (
    <select value={status} onChange={e => { const v = e.target.value; setStatus(v); fetchData(v); }} style={selectSx}>
      <option value="-1">Todos os status</option>
      <option value="0">Ativos</option>
      <option value="1">Inativos</option>
    </select>
  );

  if (loading) return <Loading />;

  return (
    <TableLayout
      title="Lista de Clientes"
      icon={null}
      count={data.length}
      columns={COLS}
      search={{ value: search, onChange: setSearch, placeholder: 'Buscar por nome, CPF/CNPJ…', onSubmit: () => fetchData() }}
      pagination={{ value: perPage, onChange: handlePerPage }}
      toolbar={Toolbar}
      fab={{ show: true, label: 'cliente', path: 'cadastrar-clientes' }}
      emptyMessage="Nenhum cliente encontrado para os filtros aplicados."
    >
      {data.map((c, i) => (
          <tr key={c.id}
            style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#f8fafc' }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#eff6ff')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = i % 2 === 0 ? '#fff' : '#f8fafc')}
          >
            <TD left uppercase>{c.nome}</TD>
            <TD>{c.cnpj_cpf}</TD>
            <TD>{c.cidade}</TD>
            <TD>{c.uf}</TD>
            <TD><StatusBadge status={c.status} /></TD>
            <TD>
              <Actions>
                <EditBtn to={`/alterar-cliente/${c.id}`} />
                <InadimplenciasBtn onClick={() => setInadimplenciasCliente(c)} />
                <DeleteBtn url={Apis.urlDeletarClientes} id={c.id} redirect="listar-clientes" component="Cliente" texto={`Deseja realmente excluir o cliente ${c.nome}`} />
              </Actions>
            </TD>
          </tr>
      ))}
      {inadimplenciasCliente && <InadimplenciasModal cliente={inadimplenciasCliente} onClose={() => setInadimplenciasCliente(null)} />}
    </TableLayout>
  );
}
